import React from "react";
import { useLanguage } from "../context/LanguageContext";

const CLIENT_LOGOS = [
  { name: "Accanto", url: "https://customer-assets.emergentagent.com/job_brand-identity-dev-2/artifacts/owh9n6o9_accanto.png" },
  { name: "Confcommercio Ascoli Piceno", url: "https://customer-assets.emergentagent.com/job_brand-identity-dev-2/artifacts/5lb6urxa_confcommercio%20ascoli.png" },
  { name: "Confidence Medical", url: "https://customer-assets.emergentagent.com/job_brand-identity-dev-2/artifacts/wpiwu6z6_confidence%20medical.png" },
  { name: "Husse", url: "https://customer-assets.emergentagent.com/job_brand-identity-dev-2/artifacts/0zngwkii_husse.png" },
  { name: "MSD Fitness Ascoli", url: "https://customer-assets.emergentagent.com/job_brand-identity-dev-2/artifacts/7fp9q8ic_msd%20fitness%20ascoli.png" },
  { name: "Time to Move", url: "https://customer-assets.emergentagent.com/job_brand-identity-dev-2/artifacts/cg6bx5tb_time%20to%20move.png" },
];

const ALL_LOGOS = [...CLIENT_LOGOS, ...CLIENT_LOGOS, ...CLIENT_LOGOS];

const ClientsSection = () => {
  const { t } = useLanguage();

  return (
    <section
      data-testid="clients-section"
      style={{
        padding: "80px 0 80px",
        background: "#fff",
        overflow: "hidden",
      }}
    >
      <h2 style={{
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 700,
        fontSize: "clamp(30px, 4vw, 50px)",
        color: "#333",
        textAlign: "center",
        margin: "0 0 56px 0",
        letterSpacing: "-1px",
      }}>
        {t.clients.title}
      </h2>

      <div style={{ position: "relative", overflow: "hidden" }}>
        {/* Fade edges */}
        <div style={{
          position: "absolute", left: 0, top: 0, bottom: 0, width: "100px",
          background: "linear-gradient(90deg, #fff, transparent)",
          zIndex: 2, pointerEvents: "none",
        }} />
        <div style={{
          position: "absolute", right: 0, top: 0, bottom: 0, width: "100px",
          background: "linear-gradient(-90deg, #fff, transparent)",
          zIndex: 2, pointerEvents: "none",
        }} />

        <div
          data-testid="logo-marquee"
          className="marquee-track"
          style={{
            display: "flex",
            gap: "8px",
            alignItems: "center",
            width: "max-content",
            padding: "8px 0",
          }}
        >
          {ALL_LOGOS.map((logo, i) => (
            <img
              key={i}
              src={logo.url}
              alt={logo.name}
              loading="lazy"
              decoding="async"
              style={{
                objectFit: "cover",
                flexShrink: 0,
                display: "block",
                border: logo.name === "Confcommercio Ascoli Piceno" ? "1px solid #000" : "none",
              }}
              className="client-logo"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
